/*                                                                  */
/*                                                              */
export type MediaQueryMatcher = (query: string) => Pick<MediaQueryList, 'matches'>;

export function isTouchDevice(matchMedia?: MediaQueryMatcher): boolean {
    if (typeof window === 'undefined') return false;
    return (matchMedia ?? window.matchMedia.bind(window))('(pointer: coarse)').matches;
}
